/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC, useEffect, useState } from 'react'
import 'react-pswp/dist/index.css'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { MdOutlineArrowForwardIos } from 'react-icons/md'
import { toast } from 'material-react-toastify'
import { InView } from 'react-intersection-observer'
import { AiOutlineLoading } from 'react-icons/ai'
import cloneDeep from 'lodash/cloneDeep'
import addOrReplaceParam from '../../utils/addQueryParam'
import { FormDrawer } from './reviews/FormDrawer'
import {
  get2HoursLocalReviews,
  saveReview,
  scrollToReviews,
} from './reviews/utils'
// import { Rating } from './reviews/Rating'
import { ReviewList } from './reviews/ReviewList'
import { ReviewListDrawer } from './reviews/ReviewListDrawer'
import { BASE_URL } from './reviews/config'
import { useWindowSize } from '../../hooks/useWindowSize'
// import { ProgressBar } from './reviews/ProgressBar'
import { RatingBox } from './reviews/RatingBox'
// import { useRecaptchaHook } from '../../hooks/useRecaptchaHook'
// import { useGetProtectedInfoHook } from '../../hooks/useGetProtectedInfoHook'

dayjs.extend(utc)
dayjs.extend(timezone)

let reviewReportData = {}
// 回调函数
// eslint-disable-next-line consistent-return
function receiveMessageFromIndex(event: any) {
  if (event.data.reviewRect) {
    const reviewsWrapper =
      // @ts-ignore
      window.document.querySelector('.reviews-wrapper')?.style
    reviewsWrapper.width = `${event.data.reviewRect.width}px`
    reviewsWrapper.height = `${event.data.reviewRect.height}px`
    reviewsWrapper.position = 'absolute'
    reviewsWrapper.left = `${event.data.reviewRect.left}px`
    reviewsWrapper.top = `${event.data.reviewRect.top}px`
    return null
  }
  if (event.data.reviewRectClear) {
    const reviewsWrapper =
      // @ts-ignore
      window.document.querySelector('.reviews-wrapper')?.style
    setTimeout(() => {
      reviewsWrapper.width = `auto`
      reviewsWrapper.height = `auto`
      reviewsWrapper.position = 'relative'
      reviewsWrapper.left = `0`
      reviewsWrapper.top = `0`
    }, 300)
    return null
  }
}

// 监听message事件
if (process.browser)
  window.addEventListener('message', receiveMessageFromIndex, false)

function disableUserEvent() {
  window.document.body.style.pointerEvents = 'none'
  setTimeout(() => {
    window.document.body.style.pointerEvents = 'unset'
  }, 200)
}
/**
 * reviews item
 */
// const ReviewsItem: FC<{
//   data?: any
//   className?: string
//   openImage: (e: any, i: number) => any
// }> = ({ data, className, openImage }) => {
//   return ()
// }

export interface Props {
  pData: any
  pTitle: string
  pid: any
  pHandle: string
  isExtension?: boolean
  onInit?: (e: any) => any // 初始化成功后的一些数据
}
const ProductsReviews: FC<Props> = ({
  pData,
  pTitle,
  pid,
  pHandle,
  isExtension = false,
  onInit,
}) => {
  const [reviewCount, setReviewCount] = useState(0)
  const [reviewAverage, setReviewAverage] = useState(0)
  const [fetchCount, setFetchCount] = useState(0)
  const [reviewList, setReviewList] = useState<any[]>([])
  const [reviewFigure, setReviewFigure] = useState<any>({})
  const [figure, setFigure] = useState({})
  // const [reviewCacheList, setReviewCacheList] = useState<any[]>([])
  const [productId, setProductId] = useState<string | number>('')
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [isLoaded, setIsLoaded] = useState<boolean>(false)
  const [showPercentBox, setShowPercentBox] = useState<boolean>(true)
  const [formDrawerOpen, setFormDrawerOpen] = useState<boolean>(false)
  const [reviewListDrawer, setReviewListDrawer] = useState<boolean>(false)
  const { upSm } = useWindowSize()
  // // @ts-ignore
  // const token = useRecaptchaHook(process.env.NEXT_PUBLIC_SITE_KEY)
  // const protectedInfo = useGetProtectedInfoHook(token)
  // console.log('@@@@ ', token, protectedInfo)
  function getMainData() {
    fetch(`${BASE_URL}/review/figure`)
      .then((res) => res.json())
      .then((data) => {
        if (data?.body?.bands?.length) {
          setFigure(data.body)
        } else {
          toast.error('Failed to fetch figure data')
        }
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.log(err)
        toast.error('Failed to fetch figure data')
      })
  }
  useEffect(() => {
    if (pid) {
      saveReview([]) // Clear expired reviews cache
      setProductId(window.atob(pid).split('/')[4])
      if (
        new URLSearchParams(window.location.search).get('target') === 'rating'
      ) {
        scrollToReviews()
      }
      getMainData()
    }
    // 卸载评论组件时（切换商品详情页时）清除商品详情页的评分
    return () =>
      onInit?.({
        rating: -1,
        total: -1,
      })
  }, [pid])

  useEffect(() => {
    if (typeof window === 'undefined') return
    const reviewCache = get2HoursLocalReviews(pHandle)
    // setReviewCacheList(reviewCache)
    const IdCacheList = reviewCache.map((i) => i.id)
    const excludeCacheIdReviews = reviewList.filter(
      (i) => !IdCacheList.includes(i.id)
    )
    let finalList = [...reviewCache, ...excludeCacheIdReviews]
    const showLimitNum = 1
    if (finalList.length > showLimitNum) {
      finalList = finalList.slice(0, showLimitNum)
    }
    setReviewList(finalList)
    // console.log(finalList)
    // setReviewList([])
  }, [formDrawerOpen, fetchCount])

  async function getReviewList(scroll: boolean = false) {
    try {
      setIsLoading(true)
      reviewList.length = 0
      const param = addOrReplaceParam(`${BASE_URL}/review`, 'handle', pHandle)
      // const param = addOrReplaceParam(`${BASE_URL}/reviews`, 'productId', productId)
      // const res = await fetch(`${param}&limit=3`)
      const res = await fetch(`${param}&limit=3&sortKey=MEDIA_FIRST`)
      if (res.status === 200 && res.ok) {
        const data = await res.json()
        const result = cloneDeep(data.body)
        if (data.status === 200) {
          setReviewCount(data.body.count)
          setReviewAverage(data.body.average)
          setReviewList(data.body.items)
          const fig = data.body.reviewFit
          let reviewFitCalc: any = {}

          if (fig && fig.total > 0) {
            const computedPercent = (
              total: number,
              arrs: number[],
              fixed = 0
            ) => arrs.map((i) => Number(((i * 100) / total).toFixed(fixed)))
            const [smPer, lgPer] = computedPercent(fig.total, [
              fig.small,
              fig.large,
            ])
            const truePer = 100 - smPer - lgPer
            const isShow =
              fig.total >= 10 && Math.max(smPer, truePer, lgPer) >= 7 * 1e1
            reviewFitCalc = {
              smPer,
              truePer,
              lgPer,
              show: isShow,
            }
            setReviewFigure({ ...fig, smPer, truePer, lgPer })
            setShowPercentBox(true)
          } else {
            reviewFitCalc = { show: false }
            setShowPercentBox(false)
          }
          setFetchCount(fetchCount + 1)
          setTimeout(() => {
            window.parent.postMessage(
              {
                // @ts-ignore
                reviewNewRect: document
                  .querySelector('.reviews-wrapper')
                  .getBoundingClientRect(),
              },
              '*'
            )
            window.parent.postMessage(
              {
                value: Object.assign(result, { reviewFitCalc }),
                reviewOnReday: true,
              },
              '*'
            )
          })
          onInit?.({
            rating: data.body.average.toFixed(1),
            total: data.body.count,
          })
        } else {
          toast.error(
            data.message ||
              'Server error, please feed back through the customer service plug-in'
          )
        }
      }
    } catch (e: any) {
      console.log(e)
      toast.dark(
        'Oops, fetch data failed. Please check your network and try again.'
      )
    }
    setIsLoaded(true)
    setIsLoading(false)
    // const [mod, res] = await Promise.all([
    //   import('cheerio'),
    //   fetch(
    //     ttParams(`${BASE_HTML_URL}/reviews/reviews_for_widget`, {
    //       ...searchParams,
    //       product_id: productId,
    //     }) as string
    //   ),
    // ])
    // setReviewData({ ...reviewData, total: totalNum * 5 })
    // setReviewList(listArr)
    // console.log('List data-->', listArr)
    if (scroll) {
      scrollToReviews()
    }
  }
  function registerMessage() {
    window.addEventListener('message', (data) => {
      const { data: datas } = data
      switch (datas.action) {
        case 'openReviewList':
          setReviewListDrawer(true)
          break
        default:
          break
      }
    })
  }
  /*
  useEffect(() => {
    if (productId && !formDrawerOpen) {
      getReviewList()
    }
  }, [productId, formDrawerOpen])
  */
  useEffect(() => {
    if (productId) {
      getReviewList()
    }
  }, [productId])

  useEffect(() => {
    if (productId && pData.spu && fetchCount) {
      reviewReportData = {
        product_from_page:
          localStorage.getItem(`product_from_page-${pData.spu ?? ''}`) ?? '',
        product_spu: pData.spu,
        product_name: pTitle,
        is_available: pData.available,
        web_original_price: +pData.compareAtPrice,
        web_current_price: +pData.price,
        web_discount_price: +(pData.compareAtPrice - pData.price).toFixed(2),
        review_number: reviewCount,
        average_overall_rating: +reviewAverage.toFixed(1),
        is_refactor: !isExtension,
      }
    }
  }, [pData.spu, fetchCount])
  useEffect(() => {
    registerMessage()
  }, [])
  return (
    <div
      className={`reviews-wrapper relative min-h-full ${
        pData.platform === 'pc' || upSm
          ? 'p-4 pb-0 border-1 border-gray-100'
          : `pt-4 ${isExtension ? ' px-0 pb-0' : ' px-4 pb-0'}`
      }`}
    >
      {fetchCount > 0 && !!pData.spu ? (
        <InView
          className="absolute top-0 left-0 w-full"
          initialInView={false}
          triggerOnce
          threshold={1}
          onChange={(e) => {
            if (e) {
              const reviewFrom = window.localStorage.getItem('review_from')
              if (reviewFrom) {
                window.localStorage.removeItem('review_from')
              }
              console.log('ReviewRegionShow', {
                ...reviewReportData,
                check_review_method: +(reviewFrom || 3),
              })
              window?.sensors?.track('ReviewRegionShow', {
                ...reviewReportData,
                check_review_method: +(reviewFrom || 3),
              })
            }
          }}
        >
          <div className="block opacity-0 h-36 w-full bg-tag-yellow-light" />
        </InView>
      ) : null}
      <h2 className="text-black flex justify-between items-center relative">
        <div className="text-sm font-semibold md:font-bold md:text-lg">
          Reviews
          {reviewCount ? ` (${reviewCount > 999 ? '999+' : reviewCount})` : ''}
        </div>
        {isLoaded && (
          <div
            className="border-1 h-7 inline-flex items-center justify-center text-xs px-4 cursor-pointer border-tag-grayccc select-none"
            onClick={() => {
              setTimeout(() => setFormDrawerOpen(true), 50)
              window.parent.postMessage(
                {
                  reviews: 'OpenFullScreen',
                },
                '*'
              )
              window?.sensors?.track('WriteReviewButtonClick', reviewReportData)
              console.log('WriteReviewButtonClick', reviewReportData)
              window?.sensors?.track('WriteReviewPannelShow', reviewReportData)
              console.log('WriteReviewPannelShow', reviewReportData)
            }}
          >
            Write A Review
          </div>
        )}
      </h2>
      <div
        className={`flex ${
          reviewCount || reviewList.length
            ? 'justify-between'
            : 'justify-center py-7 mb-2'
        } items-center mt-4 bg-tag-grayf5 text-sm font-medium`}
      >
        {reviewCount || reviewList.length ? (
          <RatingBox
            reviewList={reviewList}
            reviewFigure={reviewFigure}
            reviewAverage={reviewAverage}
            showPercentBox={showPercentBox}
            preRight="pl-7"
          />
        ) : !fetchCount ? (
          <span className="animate-spin inline-block">
            <AiOutlineLoading size={24} />
          </span>
        ) : (
          'No reviews yet'
        )}
      </div>
      <ReviewList
        figure={figure}
        reviewList={reviewList}
        previewLimit={3}
        disableViewMore
      />
      {(reviewCount || 0) > 0 && !!pData.spu ? (
        <InView
          initialInView={false}
          triggerOnce
          threshold={1}
          onChange={(e) => {
            if (e) {
              console.log('ViewAllReviewButtonShow', reviewReportData)
              window?.sensors?.track(
                'ViewAllReviewButtonShow',
                reviewReportData
              )
            }
          }}
        >
          <div
            className="flex justify-center items-center py-3 text-gray-400 text-xs cursor-pointer"
            onClick={() => {
              setTimeout(() => setReviewListDrawer(true), 50)
              window.parent.postMessage(
                {
                  reviews: 'OpenFullScreen',
                },
                '*'
              )
              window?.sensors?.track(
                'ViewAllReviewButtonClick',
                reviewReportData
              )
              console.log('ViewAllReviewButtonClick', reviewReportData)
              window?.sensors?.track('ReviewListShow', reviewReportData)
              console.log('ReviewListShow', reviewReportData)
            }}
          >
            View All
            <MdOutlineArrowForwardIos
              color="inherit"
              fontSize="10"
              className="ml-1"
            />
          </div>
        </InView>
      ) : null}
      <FormDrawer
        drawerOpen={formDrawerOpen}
        onClose={() => {
          setFormDrawerOpen(false)
          if (isExtension) {
            disableUserEvent()
            window.parent.postMessage({ reviews: 'CloseFullScreen' }, '*')
          }
          window?.sensors?.track('WriteReviewPannelClose', reviewReportData)
          console.log('WriteReviewPannelClose', reviewReportData)
        }}
        figure={figure}
        productId={productId}
        pTitle={pTitle}
        pCover={pData.pCover}
        pHandle={pHandle}
        reviewReportData={reviewReportData}
        platform={pData?.platform ?? ''}
        // todo: 需要通过路由查询来判断是否来源邮箱
        isEmail={pData?.isEmail ?? false}
        isExtension={isExtension}
        loginEmail={pData.email || ''}
      />
      <ReviewListDrawer
        figure={figure}
        drawerOpen={reviewListDrawer}
        onClose={(stayTime: any) => {
          setReviewListDrawer(false)
          if (isExtension) {
            disableUserEvent()
            window.parent.postMessage({ reviews: 'CloseFullScreen' }, '*')
          }
          window?.sensors?.track('ReviewListLeave', {
            ...reviewReportData,
            stay_time: stayTime,
          })
          console.log('ReviewListLeave', {
            ...reviewReportData,
            stay_time: stayTime,
          })
        }}
        // productId={productId}
        pHandle={pHandle}
        reviewReportData={reviewReportData}
        isExtension={isExtension}
      />
    </div>
  )
}

export default ProductsReviews
